import { render, staticRenderFns } from "./TheContainerHeader.vue?vue&type=template&id=15c4f1bc&scoped=true&"
import script from "./TheContainerHeader.vue?vue&type=script&lang=ts&"
export * from "./TheContainerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TheContainerHeader.vue?vue&type=style&index=0&id=15c4f1bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4f1bc",
  null
  
)

export default component.exports